import { Route, Routes } from 'react-router-dom';
import { PopupAdminMain } from './components/containers/PopupAdminMain';

export const Popups = () => {
  return (
    <Routes>
      <Route path="/" element={<PopupAdminMain />} />
    </Routes>
  );
};